import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface DrawerContentProps {
  content: ReactNode | ReactNode[];
  actions?: ReactNode | ReactNode[];
}

export const DrawerContent = ({ content, actions }: DrawerContentProps) => (
    // <VerticalContainer
    //     minHeight="100%"
    //     after={<>
    //         <Divider sx={{ margin: "1rem 0" }} />
    //         {actions}
    //     </>}
    // >
    //     <Box display="flex" flexDirection="column" margin="24px" height="100%" sx={{ overflowY: "auto" }}>
    //         {content}
    //     </Box>
    // </VerticalContainer>
    <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        flexGrow={2}
        sx={{ margin: "1.5rem" }}
    >
        <Box display="flex" flexDirection="column" flexGrow={2}>
            {content}
        </Box>
        <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginTop: "1.5rem" }}
        >
            {actions}
        </Box>
    </Box>
);
